// Мобилният изглед: по една карта на ред вместо хоризонтален скрол.
//
// Справката подава своя карта — общата транспозиция „по един ред на колона"
// прави от 12 колони карта от 12 реда и на телефона се събира един запис.

import type { Row } from "@tanstack/react-table";
import type { ReactNode } from "react";

type Props<TData> = {
  rows: Row<TData>[];
  renderCard: (row: TData) => ReactNode;
  onRowClick?: (row: TData) => void;
  refreshing?: boolean;
};

export const MobileCards = <TData,>({
  rows,
  renderCard,
  onRowClick,
  refreshing = false,
}: Props<TData>) => (
  <ul
    className={`flex flex-col gap-2 p-3 transition-opacity ${
      refreshing ? "opacity-60" : ""
    }`}
  >
    {rows.map((row) => (
      <li key={row.id}>
        {onRowClick ? (
          <button
            type="button"
            onClick={() => onRowClick(row.original)}
            className="w-full rounded-xl border border-shade-2 bg-surface p-3 text-left transition-colors active:bg-shade-1"
          >
            {renderCard(row.original)}
          </button>
        ) : (
          <div className="rounded-xl border border-shade-2 bg-surface p-3">
            {renderCard(row.original)}
          </div>
        )}
      </li>
    ))}
  </ul>
);
